import React from 'react';

import'./styles.css';

function ClientProfile() {
  return (
    <section className="client-profile"></section>
  );
}

export default ClientProfile;